import React from "react";
import { useNotificationPermission } from "../../../hooks/useNotificationPermission";
import { useFcmForeground } from "../../../hooks/useFcmForeground";
import { useNativeBridge } from "../../../hooks/useNativeBridge";

/**
 * Mounts the realtime-notifications side-effects exactly once, near the app
 * root. This is the single owner of the FCM lifecycle — the inverse of the old
 * Pusher setup where every component opened its own connection.
 *
 * - permission + FCM token registration (useNotificationPermission)
 * - foreground onMessage -> notifications slice + toast (useFcmForeground)
 *
 * Background/closed delivery is handled by public/firebase-messaging-sw.js
 * (browser) or native Android FCM (WebView).
 */
const FirebaseNotificationsProvider: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  // Auto-syncs the token when permission is already granted and exposes the
  // prompt flow for permission UIs to consume via the same hook.
  useNotificationPermission();

  // Single foreground message listener for the whole app (browser).
  useFcmForeground();

  // Native Android bridge: window.NineFindsNative + onWebAppReady signal.
  useNativeBridge();

  return <>{children ?? null}</>;
};

export default FirebaseNotificationsProvider;
